import { render, staticRenderFns } from "./TeamDefinitionEdit.vue?vue&type=template&id=0f0b2607&"
import script from "./TeamDefinitionEdit.vue?vue&type=script&lang=js&"
export * from "./TeamDefinitionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports